import { CommonModule, NgIfContext } from '@angular/common';
import { Directive, EmbeddedViewRef, Input, NgModule, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { UserService } from '../services/user';

@Directive({
  selector: '[toAuthorize]'
})
export class AuthorizeDirective implements OnInit {
  private _authorized: string[];
  private _context: NgIfContext = new NgIfContext();
  private _thenTemplateRef: TemplateRef<NgIfContext> | null = null;
  private _elseTemplateRef: TemplateRef<NgIfContext> | null = null;
  private _thenViewRef: EmbeddedViewRef<NgIfContext> | null = null;
  private _elseViewRef: EmbeddedViewRef<NgIfContext> | null = null;

  @Input()
  set toAuthorize(authorized: string[]) {
    this._authorized = authorized;
    this._updateView();
  }

  @Input()
  set toAuthorizeThen(templateRef: TemplateRef<NgIfContext> | null) {
    this.assertTemplate('toAuthorizeThen', templateRef);
    this._thenTemplateRef = templateRef;
    this._thenViewRef = null; // clear previous view if any.
    this._updateView();
  }

  @Input()
  set toAuthorizeElse(templateRef: TemplateRef<NgIfContext> | null) {
    this.assertTemplate('toAuthorizeElse', templateRef);
    this._elseTemplateRef = templateRef;
    this._elseViewRef = null; // clear previous view if any.
    this._updateView();
  }

  constructor(
    private _viewContainer: ViewContainerRef,
    private _templateRef: TemplateRef<NgIfContext>,
    private _userService: UserService
  ) {
    this._thenTemplateRef = this._templateRef;
  }

  ngOnInit(): void {
    this._userService.userGroups().pipe(take(1)).subscribe(groups => {
      this._context.$implicit = this._context.ngIf = this._authorized.some(group => groups[group]);
      this._updateView();
    });
  }

  private assertTemplate(property: string, templateRef: TemplateRef<any> | null): void {
    const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
    if (!isTemplateRefOrNull) {
      throw new Error(`${property} must be a TemplateRef'.`);
    }
  }

  private _updateView() {
    if (this._context.$implicit) {
      if (!this._thenViewRef) {
        this._viewContainer.clear();
        this._elseViewRef = null;
        if (this._thenTemplateRef) {
          this._thenViewRef = this._viewContainer.createEmbeddedView(
            this._thenTemplateRef,
            this._context
          );
        }
      }
    } else {
      if (!this._elseViewRef) {
        this._viewContainer.clear();
        this._thenViewRef = null;
        if (this._elseTemplateRef) {
          this._elseViewRef = this._viewContainer.createEmbeddedView(
            this._elseTemplateRef,
            this._context
          );
        }
      }
    }
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [AuthorizeDirective],
  exports: [AuthorizeDirective]
})
export class AuthorizeModule { }
